module.exports = {
  "source": ".intlSubNavStickyBarHideOnMobile__stickyBar___kU0Sr{\n  height:52px;\n  width:100%; }\n.intlSubNavStickyBarHideOnMobile__stickyBarHide___15_M0 .intlSubNavStickyBarHideOnMobile__wrapper___3OKyp{\n  position:relative; }\n.intlSubNavStickyBarHideOnMobile__wrapper___3OKyp{\n  width:100%;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-pack:center;\n      -ms-flex-pack:center;\n          justify-content:center;\n  position:fixed;\n  z-index:20;\n  background:#fff;\n  top:0;\n  left:0; }\n.intlSubNavStickyBarHideOnMobile__children___3br9Z{\n  width:100%;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex; }\n.intlSubNavStickyBarHideOnMobile__actionLeft___sMWY3,\n.intlSubNavStickyBarHideOnMobile__actionRight___3AYRC{\n  display:none; }\n.intlSubNavStickyBarHideOnMobile__actionHide___1YPqu{\n  visibility:hidden; }\n@media (max-width: 767px){\n  .intlSubNavStickyBarHideOnMobile__stickyBar___kU0Sr{\n    display:none; } }\n",
  "classNames": {
    "stickyBar": "intlSubNavStickyBarHideOnMobile__stickyBar___kU0Sr",
    "stickyBarHide": "intlSubNavStickyBarHideOnMobile__stickyBarHide___15_M0",
    "wrapper": "intlSubNavStickyBarHideOnMobile__wrapper___3OKyp",
    "children": "intlSubNavStickyBarHideOnMobile__children___3br9Z",
    "actionLeft": "intlSubNavStickyBarHideOnMobile__actionLeft___sMWY3",
    "actionRight": "intlSubNavStickyBarHideOnMobile__actionRight___3AYRC",
    "actionHide": "intlSubNavStickyBarHideOnMobile__actionHide___1YPqu"
  },
  "classNameHash": {
    "intlSubNavStickyBarHideOnMobile__stickyBar___kU0Sr": "stickyBar",
    "intlSubNavStickyBarHideOnMobile__stickyBarHide___15_M0": "stickyBarHide",
    "intlSubNavStickyBarHideOnMobile__wrapper___3OKyp": "wrapper",
    "intlSubNavStickyBarHideOnMobile__children___3br9Z": "children",
    "intlSubNavStickyBarHideOnMobile__actionLeft___sMWY3": "actionLeft",
    "intlSubNavStickyBarHideOnMobile__actionRight___3AYRC": "actionRight",
    "intlSubNavStickyBarHideOnMobile__actionHide___1YPqu": "actionHide"
  }
};

module.exports.getClassName = function(name, defaultValue) {
    return module.exports.classNames[name] || defaultValue;
};

module.exports.getClassNameHash = function(name, defaultValue) {
  return module.exports.classNameHash[name] || defaultValue;
};

module.exports.toString = function() {
  return module.exports.source;
};
